import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ReactNode } from 'react';

import { GameplayTierBadge } from '#src/components/card/GameplayTierBadge/index.tsx';

import type { NBAGameplayTierBadge_anyPlayerInterface } from './__generated__/index.graphql.ts';

type Props = {
  anyPlayer: NBAGameplayTierBadge_anyPlayerInterface;
  height?: number;
  className?: string;
  l10Tab?: ReactNode;
  overCap?: boolean;
};

export const NBAGameplayTierBadge = ({
  anyPlayer,
  height,
  className,
  l10Tab,
  overCap,
}: Props) => {
  const { gameplayTier, lastTenPlayedSo5AverageScore } = anyPlayer;
  if (!gameplayTier) {
    return null;
  }

  return (
    <GameplayTierBadge
      gameplayTier={gameplayTier}
      l10Score={lastTenPlayedSo5AverageScore}
      height={height}
      className={className}
      l10Tab={l10Tab}
      overCap={overCap}
    />
  );
};

NBAGameplayTierBadge.fragments = {
  anyPlayerInterface: gql`
    fragment NBAGameplayTierBadge_anyPlayerInterface on AnyPlayerInterface {
      slug
      gameplayTier
      lastTenPlayedSo5AverageScore: averageScore(
        type: LAST_TEN_PLAYED_SO5_AVERAGE_SCORE
      )
    }
  ` as TypedDocumentNode<NBAGameplayTierBadge_anyPlayerInterface>,
};
